const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';

export function useDevLogger() {
    const devLog = (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    };

    const devWarn = (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    };

    const devError = (...args) => {
        if (isDevelopment) {
            console.error(...args);
        }
    };

    const devInfo = (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    };

    const devDebug = (...args) => {
        if (isDevelopment) {
            console.debug(...args);
        }
    };

    const devTable = (data) => {
        if (isDevelopment) {
            console.table(data);
        }
    };

    return {
        devLog,
        devWarn,
        devError,
        devInfo,
        devDebug,
        devTable
    };
}

// *** USAGE EXAMPLE ***
// <script setup>
// import { useDevLogger } from '@/composables/useDevLogger';
//
// const { devLog, devWarn, devError, devInfo, devDebug, devTable } = useDevLogger();
//
// // In your component or other files:
// devLog('This will only show in development');
// devWarn('Warning message in development only');
// devError('Error details in development only');
// devInfo('Info message in development only');
// devDebug('Debug message in development only');
// devTable([{ id: 1, name: 'Test' }]); // Tables in development only